import * as React from 'react';
import * as TinyMCE from 'react-tinymce';
import { OutputReferenceHelper, IdHelper, ModalHelper, EOutputLookupContext, SetOutputMethodType } from '../../helpers';
import { IDropdownOption, Label, TextField } from 'office-ui-fabric-react';
import '../../plugins/output-reference/plugin';
import { ContentEditableTinyMCE } from './content-editable-tinymce';
declare var tinymce;

interface IProps {
    value: string;
    richText: boolean;
    outputOptions: IDropdownOption[];
    label?: string;
    singleLine?: boolean;
    tabIndex?: number;
    required?: boolean;
    readonly: boolean;
    outputLookupContext: EOutputLookupContext;
    onBlur: (value: string) => void;
    updateFieldName?: () => void;
    isEntityProperty?: boolean;
    disabled?: boolean;
}

export class EntityFieldTinyMCE extends React.Component<IProps, any> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            showTinyMCE: false
        }
        this.changeShowTinyMCE = this.changeShowTinyMCE.bind(this);
    }

    changeShowTinyMCE(showTinyMCE: boolean) {
        this.setState({
            showTinyMCE: showTinyMCE,
        });

    }
    valueToRender: string = '';

    render() {

        let { value, richText, outputOptions, onBlur, label, singleLine, tabIndex, required, readonly, outputLookupContext, isEntityProperty, disabled } = this.props;

        let markup = '';

        try {
            let content = JSON.parse(value);
            if (content.markup) {
                markup = content.markup;
            }
        } catch (e) {
            markup = '';
        }

        this.valueToRender = OutputReferenceHelper.decodeTokens(markup, outputOptions);


        return (

            !disabled && (this.state.showTinyMCE || this.valueToRender) ?
                <ContentEditableTinyMCE
                    tabIndex={tabIndex}
                    value={value}
                    onBlur={onBlur}
                    richText={richText}
                    outputOptions={outputOptions}
                    singleLine={true}
                    readonly={false}
                    outputLookupContext={EOutputLookupContext.NotSpecified}
                    isEntityProperty={false}
                    autoFocus={true}
                />
                : <TextField disabled={disabled} title={disabled ? 'Check the right box to set default value.' : null} className="fields-textfield" onClick={() => this.changeShowTinyMCE(true)} />
            // : <Label onClick={() => this.changeShowTinyMCE(true)} >Open Editor</Label>

        );
    }

}


// WEBPACK FOOTER //
// ./source/ts/components/output-reference/entity-field-tinymce.tsx